import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import SquareAvatar from "../../commonComponent/SquareAvatar";
import { BsThreeDots } from "react-icons/bs";
import CareTeamNoProvider from "../../svg/CareTeamNoProviderSvg.svg";
import { AiOutlinePlusCircle } from "react-icons/ai";
import {
  getCareTeamProvider,
  getPatientListCareTeam,
} from "../../services/CareTeam";
import Loader from "../../commonComponent/Loader";
import AddProviders from "./AddProviders";
import { useCareTeamContext } from "../../Context/CareTeamContext";
import AssignGrouptoProviderModal from "./AssignGrouptoProviderModal";
import AssignCareTeamtoProvider from "./AssignCareTeamtoProvider";
import AssignPatientProviderModal from "./AssignPatienttoProviderModal";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";

const AllProviders = ({ searchTerm }) => {
  const { allProvider, isLoading, setAllProvider } = useCareTeamContext();
  const [filterdata, setFilterData] = useState([]);
  const [providerId, setProviderId] = useState("");
  const [modalOpen, setModalOpen] = useState(false); // Track modal open state
  const [provider, setProvider] = useState({});
  const [teamsProviderList, setTeamsProviderList] = useState([]);
  const [filterData2, setFilterData2] = useState([])
  const [loader, setLoader] = useState(true);
  useEffect(() => {
    setFilterData(allProvider);
  }, [allProvider.length]);

  const getAllProvidersNew = async () => {
    try {
      const response = await getCareTeamProvider();
      if (response.status !== 200) {
        setFilterData([]);
        return;
      }
      setFilterData(response?.data?.data);
      setAllProvider(response?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getTeamsProvidersNew = async () => {
    try {
      const response = await getPatientListCareTeam();
      if (response.status !== 200) {
        setTeamsProviderList([]);
        setLoader(false);
        return;
      }
      setTeamsProviderList(response?.data?.data);
      setFilterData2(response?.data?.data);
      setLoader(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllProvidersNew();
    getTeamsProvidersNew();
    if (!modalOpen) {
      setProviderId("");
    }
  }, [modalOpen]);

  useEffect(() => {
    onSearch(searchTerm);
  }, [searchTerm]);

  const onSearch = async (searchTerm) => {
    let searchWord = searchTerm;
    const result = allProvider.filter((value) => {
      if (value) {
        return value?.full_name
          ?.toLowerCase()
          ?.includes(searchWord?.toLowerCase());
      }
    });
    
    const result1 = teamsProviderList.filter((value) => {
      if (value) {
        return value?.full_name
          ?.toLowerCase()
          ?.includes(searchWord?.toLowerCase());
      }
    });

    if (searchWord === "") {
      setFilterData(allProvider);
      setFilterData2(teamsProviderList)
      // getGroupLists(searchWord);
    } else {
      setFilterData(result);
      setFilterData2(result1)
    }
  };

  const handleAssign = (id) => {
    setProviderId(id);
  };

  const renderList = (providers) => {
    const result = providers.map((provider) => (
      <tr className="" key={provider._id}>
        <td className="text-muted ">
          <SquareAvatar
            src={"images/avatar.png"}
            className="member_listimage squre_image2"
          />
          <span className="ms-3">{provider?.full_name}</span>
        </td>
        <td className="text-muted text-center">{provider?.role}</td>
        <td className="text-muted text-center">{provider?.docCategory}</td>
        <td className="text-muted text-center">25/55</td>
        <td
          className={`${
            provider?.status === "inactive"
              ? "text-danger text-center"
              : "text-success text-center"
          }`}
        >
          {provider?.status === "inactive" ? "Inactive" : "Active"}
        </td>
        <td
          className="text-muted fw-bold text-left overflow-visible text-center"
          style={{ cursor: "pointer" }}
        >
          {provider?.status === "active" && (
            <Dropdown>
              <Dropdown.Toggle
                variant="light"
                className="custom"
                id="dropdown-basic"
              >
                <BsThreeDots className="icon" />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  data-bs-toggle={"modal"}
                  data-bs-target={"#assignpatientproviders"}
                  onClick={() => {
                    setModalOpen(true);
                    handleAssign(provider?._id);
                    setProvider(provider);
                  }}
                >
                  Assign to patient
                </Dropdown.Item>
                <Dropdown.Item
                  data-bs-toggle={"modal"}
                  data-bs-target={"#assigngroupproviders"}
                  onClick={() => {
                    setModalOpen(true);
                    handleAssign(provider?._id);
                  }}
                >
                  Assign to group
                </Dropdown.Item>
                <Dropdown.Item
                  data-bs-toggle={"modal"}
                  data-bs-target={"#assigncareteamproviders"}
                  onClick={() => {
                    setModalOpen(true);
                    handleAssign(provider?._id);
                  }}
                >
                  Assign to team
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )}
        </td>
      </tr>
    ));

    return result;
  };

  return (
    <>
      <div className="mt-2">
        <button
          className="py-2 px-3 border-0 d-flex justify-content-center align-items-center gap-1"
          style={{
            backgroundColor: "rgba(31, 126, 120, 1)",
            color: "white",
            boxShadow: "4px 4px 40px 0px rgba(0, 0, 0, 0.2)",
          }}
          data-bs-toggle="modal"
          data-bs-target="#addproviders"
        >
          <AiOutlinePlusCircle size={"20px"} /> Add providers
        </button>
        <Tabs className="mt-2">
          <TabList>
            <Tab>
              <span className="resFont">Team providers</span>
            </Tab>
            <Tab>
              <span className="resFont">All providers</span>
            </Tab>
          </TabList>
          <TabPanel>
            <Loader
              visible={loader}
              mainStyle={{ height: "500px" }}
              noAnyData={!(filterData2.length > 0)}
            />
            {filterData2?.length > 0 && (
              <div
                style={{ height: "500px" }}
                className="overflow-y-scroll Dash"
              >
                <table
                  class="table table-hover"
                  style={{ marginTop: "0px", maxHeight: "500px" }}
                >
                  <thead>
                    <tr>
                      <td className="py-4 text-center">Name</td>
                      <td className="py-4 text-center">Role</td>
                      <td className="py-4 text-center">Category</td>
                      <td className="py-4 text-center">Capacity</td>
                      <td className="py-4 text-center">Status</td>
                      <td className="py-4 text-center">Action</td>
                    </tr>
                  </thead>
                  <tbody>{renderList(filterData2)}</tbody>
                </table>
              </div>
            )}
          </TabPanel>
          <TabPanel>
            {isLoading ? (
              <Loader
                mainStyle={{ height: "500px" }}
                mainClassName={""}
                visible={isLoading}
              />
            ) : allProvider?.length > 0 ? (
              <div
                style={{ height: "500px" }}
                className="overflow-y-scroll Dash"
              >
                <table
                  class="table table-hover"
                  style={{ marginTop: "0px", maxHeight: "500px" }}
                >
                  <thead>
                    <tr>
                      <td className="py-4 text-center">Name</td>
                      <td className="py-4 text-center">Role</td>
                      <td className="py-4 text-center">Category</td>
                      <td className="py-4 text-center">Capacity</td>
                      <td className="py-4 text-center">Status</td>
                      <td className="py-4 text-center">Action</td>
                    </tr>
                  </thead>
                  <tbody>{renderList(filterdata)}</tbody>
                </table>
              </div>
            ) : (
              <div className="d-flex justify-content-center my-5 position-relative">
                <p
                  className="w-50 text-center fw-bold z-2 "
                  style={{ color: "rgba(31, 126, 120, 1)", lineHeight: "30px" }}
                >
                  Hi to get you started, let’s begin by adding providers{" "}
                  <span
                    className="text-decoration-underline border-0 bg-white fw-bold pointer "
                    style={{ color: "rgba(31, 126, 120, 1)" }}
                    data-bs-toggle="modal"
                    data-bs-target="#addproviders"
                  >
                    click here
                  </span>{" "}
                  or on the button above
                </p>
                <img
                  className="position-absolute end-0 z-1 "
                  src={CareTeamNoProvider}
                  alt=""
                  width={"650px"}
                />
              </div>
            )}
          </TabPanel>
        </Tabs>
      </div>
      <AddProviders />
      <AssignPatientProviderModal
        provider={provider}
        members={providerId}
        getAllProviders={getAllProvidersNew}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
      />
      <AssignGrouptoProviderModal
        members={providerId}
        getAllProviders={getAllProvidersNew}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
      />
      <AssignCareTeamtoProvider
        members={providerId}
        getAllCareTeams={getAllProvidersNew}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
      />
    </>
  );
};

export default AllProviders;
